<div class="header">{{ header }}</div>
<ng-content></ng-content>
